/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMapUp = createReactComponent("map-up", "IconMapUp", [
  ["path", { d: "M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v8.5", key: "svg-0" }],
  ["path", { d: "M9 4v13", key: "svg-1" }],
  ["path", { d: "M15 7v7.5", key: "svg-2" }],
  ["path", { d: "M19 22v-6", key: "svg-3" }],
  ["path", { d: "M22 19l-3 -3l-3 3", key: "svg-4" }]
]);

export { IconMapUp as default };
//# sourceMappingURL=IconMapUp.js.map
